module.exports = __webpack_public_path__ + "assets/img/teacher (59).66691156.png";